const CONTAINER_STYLE = {
  position: "absolute",
  left: 0,
  bottom: 0
};

const TOOLTIP_STYLE = {
  position: "absolute",
  fontSize: 10,
  lineHeight: "22px",
  padding: "0px 8px",
  zIndex: 1200,
  color: "rgb(255, 255, 255)",
  backgroundColor: "rgb(97, 97, 97)",
  overflow: "hidden",
  top: 20,
  opacity: 0,
  borderRadius: 2,
  transition: "top 0.1s ease, opacity 0.1s ease",
  whiteSpace: "nowrap",
  pointerEvents: "none"
};

const SHOWN_STYLE = {
  opacity: 0.9,
  top: 0,
  pointerEvents: "auto"
};

export default ({ show, style, containerStyle, label }) => {
  return (
    <div style={Object.assign({}, CONTAINER_STYLE, containerStyle)}>
      <div style={Object.assign({}, TOOLTIP_STYLE, show && SHOWN_STYLE, style)}>
        {label}
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/app/components/partials/tooltip.jsx